import { Reveal, RevealLines } from "@/components/Reveal";

const GHOST = "/products/the-ghost-in-your-bed-full.jpg";
const MATRY = "/products/matryoshka-skin.jpg";

const TIMELINE = [
  { year: "I", title: "The Museum of Dread", text: "The house begins with a simple idea: the memories that frightened us as children were also the most vivid, the most beautiful." },
  { year: "II", title: "Sculpting Fear", text: "Each fragrance is given a face, a sculptural stopper cast from unease, from dolls, ghosts and winged things." },
  { year: "III", title: "The First Releases", text: "The signature extraits are composed, each a childhood fear given a face, a flacon and a name." },
  { year: "IV", title: "Beautifully Disturbed", text: "An independent niche house for collectors who find beauty in the uncanny, made in small, deliberate numbers." },
];

export default function Story() {
  return (
    <div data-testid="story-page">
      <section className="relative h-[70svh] overflow-hidden grain flex items-end">
        <img src={GHOST} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ filter: "brightness(0.6) saturate(0.9)" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-ink/30" />
        <div className="relative z-10 container-lux pb-20">
          <p className="label-mono mb-6 text-blood">Our World</p>
          <h1 className="heading-serif text-5xl md:text-7xl leading-[0.95]">
            <RevealLines lines={["Beauty, made", "from fear."]} />
          </h1>
        </div>
      </section>

      <section className="container-lux py-24 lg:py-36 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <h2 className="heading-serif text-3xl md:text-4xl leading-tight">
            An independent house for the beautifully disturbed
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6 lg:col-start-7 space-y-6 text-base md:text-lg text-ivory/75 font-sans leading-relaxed">
          <p>
            We are not a beauty brand. We are a small, obsessive atelier that treats perfume as art direction,
            where a fragrance arrives wearing a face, and that face remembers something you tried to forget.
          </p>
          <p>
            Dark nostalgia is our raw material. The doll, the ghost, the fairy who comes in the night. We bottle
            the feeling, not the cliché, and we refuse to make anything forgettable.
          </p>
        </Reveal>
      </section>

      <section className="grid lg:grid-cols-2">
        <div className="aspect-[4/3] lg:aspect-auto overflow-hidden">
          <img src={MATRY} alt="Sculptural flacon" className="w-full h-full object-cover" />
        </div>
        <div className="bg-onyx text-ivory flex items-center border-l border-smoke/15">
          <Reveal className="p-10 lg:p-20">
            <p className="label-mono text-blood mb-5">The Objects</p>
            <h2 className="heading-serif text-3xl md:text-4xl mb-8 leading-tight">
              Collectible by design
            </h2>
            <p className="text-base md:text-lg text-ivory/75 font-sans leading-relaxed max-w-md">
              Every flacon is conceived as a sculptural object first, a thing you would keep on the shelf long
              after the last drop. Made in limited numbers, each one is meant to unsettle and seduce in equal measure.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="container-lux py-24 lg:py-36" data-testid="story-timeline">
        <p className="label-mono mb-14 text-blood">The House, in Four Movements</p>
        <div className="space-y-px">
          {TIMELINE.map((t, i) => (
            <Reveal key={t.year} delay={i * 0.08}>
              <div className="grid md:grid-cols-12 gap-6 border-t border-smoke/20 py-10 items-start">
                <span className="md:col-span-2 font-mono text-sm text-blood tracking-[0.2em]">{t.year}</span>
                <h3 className="md:col-span-3 heading-serif text-2xl">{t.title}</h3>
                <p className="md:col-span-6 md:col-start-7 text-base text-ivory/70 font-sans leading-relaxed">{t.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
